import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;

  min-block-size: 72px;

  cursor: pointer;
`;

export const Left = styled.div`
  position: relative;

  display: flex;
  flex-basis: 45px;
  justify-content: center;

  padding-block-start: 3.4px;
`;

export const Dot = styled.div`
  position: absolute;
  z-index: 1;

  inline-size: 7px;
  block-size: 7px;

  border-radius: 50%;

  background-color: #ffca05;
`;

export const Line = styled.div`
  position: absolute;
  z-index: 0;

  block-size: 100%;
  border-inline-start: 1px dashed #979797;
`;

export const Content = styled.div`
  flex: 1;
`;

export const Time = styled.div`
  margin-block-end: 2px;

  color: #000000;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

type Props = {
  $isHighlighted: boolean;
};

export const Title = styled.span<Props>`
  display: inline-block;

  margin-block-end: 20px;

  color: ${props => (props.$isHighlighted ? "#000000" : "#999999")};
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;

  background-color: ${props => (props.$isHighlighted ? "#ffca05" : "transparent")};

  &:hover {
    color: #2c4692;
  }
`;
